import { createSlice } from "@reduxjs/toolkit";

const getLocalDateString = (d = new Date()) => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getDefaultDates = () => {
  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - 6);
  return {
    startDate: getLocalDateString(start),
    endDate: getLocalDateString(today),
  };
};

const filterSlice = createSlice({
  name: "filters",
  initialState: {
    selectedCompanyId: null,
    yards: [],
    shippingLines: [],
    useShippingLineFilter: false,
    filterMode: "date",
    currentPage: 1,
    itemsPerPage: 20,
    sortConfig: { key: null, direction: "asc" },
    activeTab: "all",
    searchQuery: "",
    days: "90",
    scrollPosition: 0,
    startDate: null,
    endDate: null,
  },
  reducers: {
    setFilters: (state, action) => ({ ...state, ...action.payload }),
    resetFilters: () => ({
      selectedCompanyId: null,
      yards: [],
      shippingLines: [],
      useShippingLineFilter: false,
      filterMode: "date",
      currentPage: 1,
      itemsPerPage: 20,
      sortConfig: { key: null, direction: "asc" },
      activeTab: "all",
      searchQuery: "",
      days: "90",
      scrollPosition: 0,
      ...getDefaultDates(),
    }),
  },
});

export const { setFilters, resetFilters } = filterSlice.actions;
export default filterSlice.reducer;